import { type ReactElement } from 'react';
import Chart from './Chart';
import { type CycledEnergyMeasurementRecord } from '@/features/BatteryMonitoring/services/battery-monitoring-api/types/battery-monitoring-api';

interface VehicleDetailProperties {
  readonly records: CycledEnergyMeasurementRecord[];
}

const CycledEnergyChart = ({ records }: VehicleDetailProperties): ReactElement => <Chart records={records} />;

export default CycledEnergyChart;
